// Widget başlığı: kullanıcı özel başlık girdiyse o, yoksa katalog adı (i18n).
import { useTranslation } from 'react-i18next';
import { WIDGET_CATALOG, type WidgetDefinition } from '../model/widgetLayout';

export function useWidgetTitle(widget: WidgetDefinition): string {
  const { t } = useTranslation();
  if (widget.title.trim()) return widget.title;
  const item = WIDGET_CATALOG.find((c) => c.type === widget.type);
  return item ? t(item.nameKey) : widget.type;
}
